export const EBookingPageType = {
  ONE_ON_ONE: '1-on-1',
  GROUP_ON_ONE: 'group-on-1',
  GROUP: 'group',
  FLEXIBLE: 'flexible',
} as const;

export type EBookingPageType = (typeof EBookingPageType)[keyof typeof EBookingPageType];

// Create a type that only includes group-related booking page types
export type EBookingPageTypeOnlyGroup =
  | typeof EBookingPageType.GROUP
  | typeof EBookingPageType.GROUP_ON_ONE;
